/**
 * Extends base Skeleton theme with colors from UX.
 *
 * @see https://github.com/chakra-ui/chakra-ui/blob/092b20f3e93064c1db312062b76b420a7ed1703b/packages/theme/src/components/skeleton.ts
 */
import { ComponentStyleConfig } from '@chakra-ui/react';
import { keyframes } from '@chakra-ui/system';
import type { SystemStyleFunction } from '@chakra-ui/theme-tools';
import { mode } from '@chakra-ui/theme-tools';

import { getColor } from '../../helpers/utils';

const fade = (startColor: string, endColor: string) =>
    keyframes({
        from: {
            borderColor: startColor,
            background: startColor
        },
        to: {
            borderColor: endColor,
            background: endColor
        }
    });
const baseStyle: SystemStyleFunction = (props) => {
    const defaultStartColor = mode('neutral.100', 'gray.800')(props);
    const defaultEndColor = mode('neutral.300', 'gray.600')(props);
    const {
        startColor = defaultStartColor,
        endColor = defaultEndColor,
        speed,
        theme
    } = props;
    const start = getColor(theme, startColor);
    const end = getColor(theme, endColor);

    return {
        opacity: 0.7,
        borderRadius: '12px',
        borderColor: start,
        background: end,
        animation: `${speed}s linear infinite alternate ${fade(start, end)}`
    };
};

export const Skeleton: ComponentStyleConfig = {
    baseStyle,
    defaultProps: { fadeDuration: 1.2 }
};
